import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { BaseUrlHelperService } from "../helper/baseUrlHelper.service";
import { NbcLoggerService } from "../logger/nbc-logger.service";


@Injectable({
  providedIn: 'root'
})
export class BusinessUnitService {
  constructor(private http: HttpClient,
    private _apiroot: BaseUrlHelperService,
    private log:NbcLoggerService) { }

   get(): Observable<any> {
    this.log.trace("get available business units");
    return this.http.get(this._apiroot.baseUrl + "businessUnit/get").pipe(
      catchError((err) => {
        return throwError(err);
      })
    );;
  }


  getBuDept(buid:any): Observable<any> {
    this.log.trace("get available business units");
    return this.http.get(this._apiroot.baseUrl + "businessUnit/departments/get/" + buid).pipe(
      catchError((err) => {
        return throwError(err);
      })
    );;
  }

}
